import { constantsData, formFieldNamesData } from "@/data";
import { AsyncDataKeyEnum, FieldTypeEnum, InputTypeEnum } from "@/enums";

const {
    name,
    type,
} = constantsData.forms.dataSources.setup.apiConnection;

const {
    name: nameFieldName,
    type: typeFieldName,
} = formFieldNamesData;

export const setupDataSourceApiConnectionFormData = [
    {
        description: name.description,
        label: name.label,
        name: nameFieldName,
        type: InputTypeEnum.TEXT,
    },
    {
        dataKey: AsyncDataKeyEnum.TYPES,
        description: type.description,
        hasOptionFormat: true,
        isAsync: true,
        label: type.label,
        name: typeFieldName,
        type: FieldTypeEnum.SELECT,
    },
];
